module.exports = __webpack_public_path__ + "img/benefit-04-camera-1.c535b5ba.png";